import Aside from "../mobiles/Aside.vue";
export default {
  components: {
    Aside
  }
};